export enum ConferenceProgramChatType {
  LIVE = 'main',
  SPEAKER = 'qa',
}
